import React from "react";
const ContentTraverserContext = React.createContext(
  null
);
const ContentTraverserContextProvider = ({
  nodeViewDecorators,
  renderers,
  SpoilerViewerWrapper,
  children
}) => {
  return /* @__PURE__ */ React.createElement(
    ContentTraverserContext.Provider,
    {
      value: { nodeViewDecorators, renderers, SpoilerViewerWrapper }
    },
    children
  );
};
export {
  ContentTraverserContext,
  ContentTraverserContextProvider
};
//# sourceMappingURL=content-traverser-context.js.map
